import { ApiProperty } from '@nestjs/swagger';
import { IsNumber, IsOptional, Min } from 'class-validator';

export class UpdateCotizacionDto {
  @ApiProperty({ example: 7300, description: 'Cotización de compra', required: false })
  @IsOptional()
  @IsNumber()
  @Min(0)
  cotizacion_compra?: number;

  @ApiProperty({ example: 7400, description: 'Cotización de venta', required: false })
  @IsOptional()
  @IsNumber()
  @Min(0)
  cotizacion_venta?: number;
}
